<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Báo cáo doanh thu sản phẩm'">
          <template v-slot:preview>
            <b-row class="mb-3">
              <b-col>
                <div
                  class="d-flex align-items-center flex-wrap"
                  style="gap: 10px"
                >
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="filterDrawerVisible = true"
                    class="mb-2 d-flex align-items-center"
                    style="gap: 6px"
                  >
                    <b-icon icon="filter" style="flex-shrink: 0"></b-icon>
                    <span>Bộ lọc</span>
                    <b-badge
                      v-if="activeFiltersCount > 0"
                      variant="white"
                      class="rounded-circle"
                    >
                      {{ activeFiltersCount }}
                    </b-badge>
                  </b-button>
                  <div
                    class="d-flex align-items-center flex-wrap"
                    v-if="activeFiltersList.length > 0"
                  >
                    <b-badge
                      v-for="filter in activeFiltersList"
                      :key="filter.key"
                      variant="light"
                      class="mr-2 mb-2 filter-badge  border border-dark text-dark"
                      style=" min-height: 37px;"
                    >
                      <span
                        class="filter-badge-label"
                        v-ellipsis-tooltip="isOverflow => (filter._showTooltip = isOverflow)"
                        v-b-tooltip.hover="filter._showTooltip ? filter.label : ''"
                      >
                        {{ filter.label }}
                      </span>

                      <b-button
                        v-if="filter.clearable"
                        variant="secondary"
                        class="ml-4 rounded-circle btn btn-xs btn-icon"
                        title="Xem báo cáo"
                        @click="removeFilter(filter.key)"
                        style="text-decoration: none; font-size: 14px;"
                      ><b-icon icon="x"></b-icon></b-button>
                    </b-badge>
                  </div>
                </div>
              </b-col>

              <b-col class="col-auto">
                <div class="d-flex justify-content-end align-items-center flex-nowrap">
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    @click="clearFilters"
                    class="mr-2 mb-2 text-nowrap"
                    :disabled="onLoading || activeFiltersCount === 0"
                  >
                    <i class="fi fi-ts-filter-slash"></i>
                    Xoá bộ lọc
                  </b-button>
                  <b-button
                    variant="outline-info"
                    size="sm"
                    @click="triggerAggregation"
                    class="mb-2 text-nowrap"
                    :disabled="onLoading"
                  >
                    <i class="flaticon2-refresh"></i>
                    Làm mới
                  </b-button>
                </div>
              </b-col>

            </b-row>

            <Drawer
              v-if="filterDrawerVisible"
              id="product-filter-drawer"
              :maskClosable="true"
              :zIndex="1002"
              @close="filterDrawerVisible = false"
              :align="align"
              :closeable="true"
            >
              <template #header>
                <div class="d-flex w-100 align-items-center justify-content-between">
                  <h5 class="mb-0 text-dark">
                    <i class="flaticon2-funnel text-primary mr-2"></i>
                    Bộ lọc báo cáo
                    <b-badge
                      v-if="activeFiltersCount > 0"
                      variant="primary"
                      class="ml-2"
                    >
                      {{ activeFiltersCount }}
                    </b-badge>
                  </h5>
                </div>
              </template>

              <div class="filter-section mb-4">
                <h6 class="filter-section-title">
                  Khoảng thời gian
                </h6>

                <b-form-group
                  label="Từ ngày"
                  label-size="sm"
                  class="mb-2"
                >
                  <date-picker
                    placeholder="Chọn ngày bắt đầu"
                    class="form-control-sm"
                    :config="dpConfigs.date"
                    v-model="filters.startDate"
                    @input="onDateChange"
                  ></date-picker>
                </b-form-group>

                <b-form-group
                  label="Đến ngày"
                  label-size="sm"
                  class="mb-3"
                >
                  <date-picker
                    placeholder="Chọn ngày kết thúc"
                    class="form-control-sm"
                    :config="dpConfigs.date"
                    v-model="filters.endDate"
                    @input="onDateChange"
                  ></date-picker>
                </b-form-group>

                <b-form-group
                  label="Chọn nhanh:"
                  label-size="sm"
                  class="mb-1"
                ></b-form-group>
                <div class="d-flex flex-wrap">
                  <b-button
                    v-for="preset in datePresets"
                    :key="preset.value"
                    :variant="selectedPreset === preset.value
                      ? 'primary'
                      : 'outline-secondary'
                    "
                    @click="applyDatePreset(preset.value)"
                    size="sm"
                    class="mr-2 mb-2 flex-fill"
                  >
                    {{ preset.label }}
                  </b-button>
                </div>
              </div>

              <div class="filter-section mb-4">
                <h6 class="filter-section-title">
                  Sản phẩm
                </h6>
                <b-form-group class="mb-3">
                  <b-form-input
                    v-model="filters.productSearch"
                    placeholder="Nhập tên, mã, mã vạch sản phẩm..."
                    size="sm"
                  />
                </b-form-group>

                <b-form-group
                  label="Danh mục"
                  label-size="sm"
                  class="mb-3"
                >
                  <treeselect
                    v-model="filters.categoryIds"
                    :options="categories"
                    :multiple="true"
                    :flat="false"
                    placeholder="Chọn danh mục"
                    :normalizer="normalizer"
                    value-consists-of="LEAF_PRIORITY"
                    :max-height="300"
                    noResultsText="Không tìm thấy kết quả"
                    :clearable="true"
                    :searchable="true"
                  />
                </b-form-group>

                <b-form-group
                  label="Thương hiệu"
                  label-size="sm"
                  class="mb-3"
                >
                  <BDropdownCustom
                    v-model="filters.brandIds"
                    :options="brands"
                    :placeholder="'thương hiệu'"
                    :searchable="true"
                    :matchKey="['name']"
                    :limit="5"
                  />
                </b-form-group>
              </div>

              <div class="filter-section mb-4">
                <h6 class="filter-section-title">
                  Cửa hàng
                </h6>
                <b-form-group>
                  <BDropdownCustom
                    v-model="filters.storeIds"
                    :options="optionStores"
                    :placeholder="'cửa hàng'"
                    :searchable="true"
                    :matchKey="['name', 'shortName']"
                    :limit="5"
                  />
                </b-form-group>
              </div>

              <div class="filter-section mb-4">
                <h6 class="filter-section-title">
                  Phân loại
                </h6>

                <b-form-group
                  label="Nguồn đơn hàng"
                  label-size="sm"
                >
                  <BDropdownCustom
                    v-model="filters.orderSourceIds"
                    :options="orderSources"
                    :placeholder="'nguồn đơn hàng'"
                    :searchable="true"
                    :matchKey="['name']"
                    :limit="5"
                  />
                </b-form-group>

              </div>

              <template #footer>
                <div class="d-flex justify-content-between w-100">
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    @click="clearFilters"
                    :disabled="activeFiltersCount === 0"
                  >
                    <i class="fa-solid fa-xmark"></i>
                    <i class="fi fi-ts-filter-slash"></i>
                    Xóa bộ lọc
                  </b-button>

                  <b-button
                    variant="primary"
                    size="sm"
                    @click="applyFiltersAndClose"
                  >
                    <i class="flaticon2-check-mark"></i>
                    Áp dụng
                  </b-button>
                </div>
              </template>
            </Drawer>

            <b-row
              v-if="trendComparison"
              class="mb-3"
            >
              <b-col cols="12">
                <b-alert
                  :variant="getComparisonVariant(trendComparison.trend)"
                  show
                  class="mb-0"
                >
                  <div class="d-flex align-items-center">
                    <i class="flaticon2-layers icon-2x mr-3"></i>
                    <div>
                      <strong>So sánh kỳ trước:</strong>
                      {{
                        trendComparison.trend === 'increase'
                          ? 'Tăng'
                          : trendComparison.trend === 'decrease'
                            ? 'Giảm'
                            : 'Không đổi'
                      }}
                      <strong>{{
                        Math.abs(trendComparison.percentageChange).toFixed(2)
                      }}%</strong>
                      ({{
                        trendComparison.trend === 'increase'
                          ? '+'
                          : trendComparison.trend === 'decrease'
                            ? '-'
                            : ''
                      }}{{
                        formatMetricValue(
                          Math.abs(trendComparison.absoluteChange),
                        )
                      }})
                      <br />
                      <small>
                        Kỳ này:
                        <strong>{{
                          formatMetricValue(trendComparison.currentTotal)
                          }}</strong>
                        vs Kỳ trước:
                        <strong>{{
                          formatMetricValue(trendComparison.previousTotal)
                          }}</strong>
                      </small>
                    </div>
                  </div>
                </b-alert>
              </b-col>
            </b-row>

            <b-row class="mb-5">
              <b-col
                cols="6"
                md="3"
                v-for="(kpi, index) in kpiCards"
                :key="index"
                class="mb-3 mb-md-0"
              >
                <b-card class="mb-3">
                  <div
                    v-if="onLoading"
                    class="text-center"
                  >
                    <b-skeleton width="60%"></b-skeleton>
                    <b-skeleton
                      width="80%"
                      height="2rem"
                      class="mt-2"
                    ></b-skeleton>
                    <b-skeleton
                      width="40%"
                      class="mt-1"
                    ></b-skeleton>
                  </div>
                  <div v-else>
                    <h6 class="text-muted">{{ kpi.label }}</h6>
                    <h3 class="mb-0">{{ kpi.value }}</h3>
                    <small
                      v-if="kpi.growth"
                      :class="getGrowthClass(kpi.growth)"
                    >
                      {{ kpi.growth > 0 ? '+' : '' }}{{ kpi.growth }}%
                    </small>
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <b-row class="mb-5">
              <b-col
                cols="12"
                lg="6"
                class="mb-3 mb-lg-0"
              >
                <b-card>
                  <div style="position: relative; min-height: 350px">
                    <div
                      v-if="onLoading"
                      class="chart-loading-overlay"
                    >
                      <b-spinner variant="primary"></b-spinner>
                    </div>
                    <div
                      v-else-if="trendData.length === 0"
                      class="text-center py-5"
                    >
                      <i class="flaticon2-line-chart icon-3x text-muted mb-3"></i>
                      <p class="text-muted">Không có dữ liệu</p>
                      <small class="text-muted">Vui lòng chọn khoảng thời gian và áp dụng bộ lọc</small>
                    </div>
                    <v-chart
                      v-else
                      :option="trendChartOption"
                      style="height: 350px"
                      autoresize
                    />
                  </div>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                lg="6"
              >
                <b-card title="Top sản phẩm">
                  <div style="position: relative; min-height: 300px">
                    <div
                      v-if="onLoading"
                      class="chart-loading-overlay"
                    >
                      <b-spinner variant="primary"></b-spinner>
                    </div>
                    <div
                      v-else-if="products.length === 0"
                      class="text-center py-5"
                    >
                      <i class="flaticon2-pie-chart-4 icon-3x text-muted mb-3"></i>
                      <p class="text-muted">Không có dữ liệu sản phẩm</p>
                      <small class="text-muted">Hãy thử điều chỉnh bộ lọc để xem kết quả</small>
                    </div>
                    <v-chart
                      v-else
                      :option="topProductsChartOption"
                      style="height: 300px"
                      autoresize
                    />
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <!-- Category Distribution Chart -->
            <b-row class="mb-5">
              <b-col
                cols="12"
                lg="12"
              >
                <b-card title="Phân bổ doanh thu theo danh mục">
                  <div style="position: relative; min-height: 300px">
                    <div
                      v-if="onLoading"
                      class="chart-loading-overlay"
                    >
                      <b-spinner variant="primary"></b-spinner>
                    </div>
                    <div
                      v-else-if="products.length === 0"
                      class="text-center py-5"
                    >
                      <i class="flaticon2-graphic icon-3x text-muted mb-3"></i>
                      <p class="text-muted">Không có dữ liệu phân bổ</p>
                      <small class="text-muted">Dữ liệu sẽ hiển thị khi có sản phẩm</small>
                    </div>
                    <v-chart
                      v-else
                      :option="categoryChartOption"
                      style="height: 300px"
                      autoresize
                    />
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <!-- Product Performance Table -->
            <b-row class="mb-5">
              <b-col cols="12">
                <b-table
                  :items="products"
                  :fields="fields"
                  :busy="onLoading"
                  class="table-bordered table-hover"
                  sort-by="doanhThuThuan"
                  :sort-desc="true"
                  @sort-changed="onSortChanged"
                  show-empty
                  empty-text="Không có dữ liệu"
                  style="margin-bottom: 0;"
                >
                  <template v-slot:table-busy>
                    <vcl-table
                      :speed="5"
                      :animate="true"
                      :columns="10"
                    ></vcl-table>
                  </template>

                  <template v-slot:cell(stt)="row">
                    <div style="text-align: center">
                      {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </div>
                  </template>

                  <template v-slot:cell(doanhThuThuan)="row">
                    <div style="text-align: right">
                      {{ formatMoney(row.item.doanhThuThuan) }}
                    </div>
                  </template>
                  <template v-slot:cell(tienHang)="row">
                    <div style="text-align: right">
                      {{ formatMoney(row.item.tienHang) }}
                    </div>
                  </template>
                  <template v-slot:cell(tienHangTraLai)="row">
                    <div style="text-align: right">
                      {{ formatMoney(row.item.tienHangTraLai) }}
                    </div>
                  </template>
                  <template v-slot:cell(thueVAT)="row">
                    <div style="text-align: right">
                      {{ formatMoney(row.item.thueVAT) }}
                    </div>
                  </template>
                  <template v-slot:cell(tongDoanhThu)="row">
                    <div style="text-align: right">
                      {{ formatMoney(row.item.tongDoanhThu) }}
                    </div>
                  </template>

                  <template v-slot:cell(productName)="row">
                    <ProductCommonInfo :product="row.item" />
                  </template>

                  <template v-slot:cell(totalSold)="row">
                    <div style="text-align: center">
                      {{ row.item.totalSold }}
                    </div>
                  </template>

                  <template v-slot:cell(donGiaTrungBinh)="row">
                    <div style="text-align: right">
                      {{ formatMoney(row.item.donGiaTrungBinh) }}
                    </div>
                  </template>
                </b-table>
              </b-col>

            </b-row>

            <b-row> <b-col
                cols="6"
                class="mb-2 mb-md-0"
              >
                <div class="d-flex align-items-center flex-wrap ">
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    class="w-auto"
                    @change="onPerPageChange"
                  >
                  </b-form-select>
                  <span class="ml-2 small">
                    Hiển thị {{ (currentPage - 1) * perPage + 1 }} -
                    {{ Math.min(currentPage * perPage, totalCount) }}
                    / {{ totalCount }} sản phẩm
                  </span>
                </div>
              </b-col>
              <b-col
                cols="6"
                class="d-flex justify-content-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  size="md"
                  @change="onPageChange"
                  class="mr-6"
                >
                </b-pagination>
              </b-col></b-row>

          </template>
        </KTCodePreview>
      </div>
    </div>

    <b-modal
      v-model="exportModal.show"
      title="Xuất báo cáo"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center py-4">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
        ></b-spinner>
        <p class="mt-3 mb-2">{{ exportModal.message }}</p>
        <small class="text-muted">{{ exportModal.subMessage }}</small>
        <b-progress
          v-if="exportModal.progress > 0"
          :value="exportModal.progress"
          :max="100"
          class="mt-3"
          animated
        ></b-progress>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { handleApiError, validateDateRange } from '@/utils/apiErrorHandler';
import { BASE_URL } from '@/utils/constants';
import timeUtils from '@/utils/date';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue';
import KTCodePreview from '@/view/content/CodePreview.vue';
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import axios from 'axios';
import debounce from 'debounce';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import moment from 'moment';
import datePicker from 'vue-bootstrap-datetimepicker';
import { VclTable } from 'vue-content-loading';
import VChart from 'vue-echarts';
import ApiService from '../../../core/services/api.service';
import { showLoadingDialog, closeSwal } from '@/utils/sweet-alert2';

const Drawer = () =>
  import(/* webpackChunkName: "Drawer" */ '@/components/common/Drawer');

use([
  LineChart,
  BarChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  CanvasRenderer,
]);

const ProductRevenueReportRepository = RepositoryFactory.get(
  'productRevenueReport',
);
const BrandRepository = RepositoryFactory.get('brands');
const CategoryRepository = RepositoryFactory.get('categories');

export default {
  name: 'ProductRevenueReport',
  mixins: [apiCommonMixin],
  components: {
    KTCodePreview,
    VclTable,
    datePicker,
    VChart,
    Drawer,
    BDropdownCustom,
    Treeselect,
    ProductCommonInfo,
  },
  data () {
    return {
      filters: {
        startDate: '',
        endDate: '',
        storeIds: [],
        categoryIds: [],
        brandIds: [],
        orderSourceIds: [],
        productSearch: '',
        search: '',
        compareWithPreviousPeriod: false,
        sortBy: 'doanhThuThuan',
        sortOrder: 'desc',
        granularity: 'day',
        metric: 'doanhThuThuan',
      },
      dpConfigs: timeUtils.DP_CONFIG,
      searchStock: '',
      stores: [],
      optionStores: [],
      pendingStoreIds: [],
      pendingOrderSourceIds: [],
      categories: [],
      brands: [],
      orderSources: [],

      filteredOptions: [],
      onLoading: false,

      exportModal: {
        show: false,
        message: 'Đang xử lý...',
        subMessage: '',
        progress: 0,
      },

      selectedPreset: null,
      datePresets: [
        { label: 'Hôm nay', value: 'today' },
        { label: '7 ngày', value: 'last7days' },
        { label: '30 ngày', value: 'last30days' },
        { label: 'Tháng này', value: 'thisMonth' },
      ],
      overview: {},
      kpiCards: [
        { label: 'Doanh thu thuần', value: '0 ₫', growth: 0 },
        { label: 'Tổng hóa đơn', value: '0', growth: 0 },
        { label: 'Giá trị TB/đơn', value: '0 ₫', growth: 0 },
        { label: 'Sản phẩm bán', value: '0', growth: 0 },
      ],
      products: [],
      fields: [
        {
          key: 'stt',
          label: 'STT',
          thStyle: { textAlign: 'center', fontWeight: 600, width: '5%' },
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          sortable: true,
          thStyle: { fontWeight: 600, width: '25%', minWidth: "270px" },
        },
        {
          key: 'totalSold',
          label: 'SL',
          sortable: true,
          thStyle: { fontWeight: 600, width: '5%', textAlign: 'center' },
        },
        {
          key: 'tienHang',
          label: 'Tiền hàng',
          sortable: true,
          thStyle: { fontWeight: 600, width: '12%', textAlign: 'center' },
        },
        {
          key: 'tienHangTraLai',
          label: 'Tiền hàng trả lại',
          sortable: true,
          thStyle: { fontWeight: 600, width: '12%', minWidth: "130px", textAlign: 'center' },
        },
        {
          key: 'thueVAT',
          label: 'Tiền thuế',
          sortable: true,
          thStyle: { fontWeight: 600, width: '12%', textAlign: 'center' },
        },
        {
          key: 'tongDoanhThu',
          label: 'Doanh thu',
          sortable: true,
          thStyle: { fontWeight: 600, width: '12%', textAlign: 'center' },
        },
        {
          key: 'doanhThuThuan',
          label: 'DT thuần',
          sortable: true,
          thStyle: { fontWeight: 600, width: '12%', textAlign: 'center' },
        },
        {
          key: 'donGiaTrungBinh',
          label: 'Giá TB',
          sortable: true,
          thStyle: { fontWeight: 600, width: '11%', textAlign: 'center' },
        },
      ],

      // Pagination
      currentPage: 1,
      perPage: 5,
      totalCount: 0,
      perPageOptions: [
        { value: 5, text: '5 / trang' },
        { value: 10, text: '10 / trang' },
        { value: 20, text: '20 / trang' },
        { value: 50, text: '50 / trang' },
      ],

      currentSort: 'doanhThuThuan',
      sortDirection: 'desc',

      lastUpdated: null,

      filterDrawerVisible: false,

      trendData: [],
      previousTrendData: null,
      categoryRevenueList: [],
      trendStatistics: null,
      trendComparison: null,
      open: false,
      innerOpen: false,
      align: 'right',
    };
  },
  computed: {
    debouncedFetchData () {
      return debounce(this.fetchData, 300);
    },
    categoryOptions () {
      return this.categories.map((cat) => ({
        value: cat.id,
        text: cat.name,
      }));
    },
    optionProducts () {
      return [...this.filteredProducts];
    },

    flattenedCategories () {
      const flatten = (items, level = 0) => {
        return items.reduce((acc, item) => {
          acc.push(item);
          if (item.children && item.children.length > 0) {
            acc.push(...flatten(item.children, level + 1));
          }
          return acc;
        }, []);
      };
      return flatten(this.categories);
    },

    activeFiltersCount () {
      let count = 0;
      if (this.filters.startDate) count++;
      if (this.filters.endDate) count++;
      if (this.filters.storeIds.length > 0) count++;
      if (this.filters.categoryIds.length > 0) count++;
      if (this.filters.brandIds.length > 0) count++;
      if (this.filters.orderSourceIds.length > 0) count++;
      if (this.filters.productSearch) count++;
      if (this.filters.search) count++;
      if (this.filters.compareWithPreviousPeriod) count++;
      return count;
    },

    activeFiltersList () {
      const filters = [];

      if (this.filters.startDate && this.filters.endDate) {
        filters.push({
          key: 'dateRange',
          label: `Ngày: ${this.filters.startDate} - ${this.filters.endDate}`,
          value: 'dateRange',
          clearable: false,
        });
      }

      if (this.filters.storeIds.length > 0) {
        const storeNames = this.filters.storeIds
          .map(s => s.shortName || s.name)
          .join(', ');
        filters.push({
          key: 'storeIds',
          label: `Cửa hàng: ${storeNames}`,
          value: this.filters.storeIds,
          clearable: true,
        });
      }

      if (this.filters.categoryIds.length > 0) {
        const categoryNames = this.filters.categoryIds
          .map(id => {
            const category = this.flattenedCategories.find(c => c.id === id);
            return category ? category.name : '';
          })
          .filter(Boolean)
          .join(', ');
        filters.push({
          key: 'categoryIds',
          label: `Danh mục: ${categoryNames}`,
          value: this.filters.categoryIds,
          clearable: true,
        });
      }

      if (this.filters.brandIds.length > 0) {
        const brandNames = this.filters.brandIds
          .map(b => b.name)
          .join(', ');
        filters.push({
          key: 'brandIds',
          label: `Thương hiệu: ${brandNames}`,
          value: this.filters.brandIds,
          clearable: true,
        });
      }

      if (this.filters.orderSourceIds.length > 0) {
        const sourceNames = this.filters.orderSourceIds
          .map(s => s.name)
          .join(', ');
        filters.push({
          key: 'orderSourceIds',
          label: `Nguồn: ${sourceNames}`,
          value: this.filters.orderSourceIds,
          clearable: true,
        });
      }

      if (this.filters.productSearch) {
        filters.push({
          key: 'productSearch',
          label: `Sản phẩm: "${this.filters.productSearch}"`,
          value: this.filters.productSearch,
          clearable: true,
        });
      }

      if (this.filters.search) {
        filters.push({
          key: 'search',
          label: `Tìm kiếm: "${this.filters.search}"`,
          value: this.filters.search,
          clearable: true,
        });
      }

      if (this.filters.compareWithPreviousPeriod) {
        filters.push({
          key: 'compareWithPreviousPeriod',
          label: 'So sánh kỳ trước',
          value: true,
          clearable: true,
        });
      }

      return filters;
    },

    trendChartData () {
      if (!this.trendData.length) return null;

      return {
        dates: this.trendData.map((item) =>
          moment(item.period).format('DD/MM'),
        ),
        revenues: this.trendData.map((item) => item.doanhThuThuan),
        previousRevenues:
          this.previousTrendData?.map((item) => item.doanhThuThuan) || null,
      };
    },

    topProductsData () {
      if (!this.products.length) return null;

      const topProducts = this.products.slice(0, 10);
      return {
        names: topProducts.map((p) => p.productName),
        revenues: topProducts.map((p) => p.doanhThuThuan),
      };
    },

    categoryRevenueData () {
      if (!this.categoryRevenueList.length) return null;

      return this.categoryRevenueList.map((category) => ({
        name: category.categoryName,
        value: category.doanhThuThuan,
      }));
    },

    trendChartOption () {
      if (!this.trendChartData) return {};

      const { dates, revenues, previousRevenues } = this.trendChartData;
      const stats = this.trendStatistics;

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          formatter: (params) => {
            let result = `<h5><strong>${params[0].name}</strong></h5>`;
            params.forEach((param, index) => {
              const dataPoint =
                param.seriesIndex === 0
                  ? this.trendData[param.dataIndex]
                  : this.previousTrendData
                    ? this.previousTrendData[param.dataIndex]
                    : null;

              if (dataPoint && index === 0) {
                result += `Doanh thu: ${this.formatMoney(
                  dataPoint.tongDoanhThu,
                )} ₫</small><br/>`;
                result += `Hóa đơn: ${dataPoint.totalBills.toLocaleString()}</small><br/>`;
                result += `SL bán: ${dataPoint.totalSold.toLocaleString()}</small><br/>`;
                result += `</div>`;
              }
            });
            return result;
          },
        },
        legend: {
          top: 0,
          left: 'center',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: this.previousTrendData ? '12%' : '8%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: dates,
          boundaryGap: false,
          axisLabel: {
            rotate: dates.length > 30 ? 45 : 0,
            fontSize: 11,
          },
        },
        yAxis: {
          type: 'value',
          name: this.getMetricLabel(this.filters.metric),
          nameTextStyle: {
            fontSize: 11,
            padding: [0, 0, 0, 10],
          },
          axisLabel: {
            formatter: (value) => this.formatMetricValue(value, true),
            fontSize: 11,
          },
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
          {
            type: 'slider',
            start: 0,
            end: 100,
            height: 25,
            bottom: 10,
          },
        ],
        series: [
          {
            type: 'line',
            smooth: true,
            data: revenues,
            areaStyle: {
              opacity: 0.3,
            },
            itemStyle: {
              color: this.getTrendColor(stats?.trend),
            },
            lineStyle: {
              width: 2,
            },
            symbolSize: 6,

            markPoint: stats
              ? {
                data: [
                  {
                    name: 'Cao nhất',
                    value: this.formatMetricValue(stats.peak.value),
                    coord: [
                      dates.indexOf(this.formatPeriod(stats.peak.period)),
                      stats.peak.value,
                    ],
                    itemStyle: {
                      color: '#1BC5BD',
                    },
                    label: {
                      fontSize: 10,
                      formatter: '{b}\n{c}',
                    },
                  },
                  {
                    name: 'Thấp nhất',
                    value: this.formatMetricValue(stats.lowest.value),
                    coord: [
                      dates.indexOf(this.formatPeriod(stats.lowest.period)),
                      stats.lowest.value,
                    ],
                    itemStyle: {
                      color: '#F64E60',
                    },
                    label: {
                      fontSize: 10,
                      formatter: '{b}\n{c}',
                    },
                  },
                ],
                symbolSize: 50,
              }
              : undefined,

            markLine: stats
              ? {
                silent: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#FFA800',
                  width: 2,
                },
                data: [
                  {
                    name: 'Trung bình',
                    yAxis: stats.average,
                    label: {
                      formatter: 'TB: {c}',
                      fontSize: 10,
                    },
                  },
                ],
              }
              : undefined,
          },
        ],
      };

      if (previousRevenues) {
        option.series.push({
          name: 'Kỳ trước',
          type: 'line',
          smooth: true,
          data: previousRevenues,
          areaStyle: {
            opacity: 0.2,
          },
          itemStyle: {
            color: '#B5B5C3',
          },
          lineStyle: {
            type: 'dashed',
            width: 2,
          },
          symbolSize: 5,
        });
      }

      return option;
    },

    topProductsChartOption () {
      if (!this.topProductsData) return {};

      const { names, revenues } = this.topProductsData;

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            return `${params[0].name}<br/>Doanh thu: ${this.formatMoney(
              params[0].value,
            )} ₫`;
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => this.formatMoneyShort(value),
          },
        },
        yAxis: {
          type: 'category',
          data: names,
          axisLabel: {
            formatter: (value) => {
              return value.length > 20 ? value.substring(0, 20) + '...' : value;
            },
          },
        },
        series: [
          {
            name: 'Doanh thu',
            type: 'bar',
            data: revenues,
            itemStyle: {
              color: '#1BC5BD',
            },
            label: {
              show: true,
              position: 'right',
              formatter: (params) => this.formatMoneyShort(params.value),
            },
          },
        ],
      };
    },

    categoryChartOption () {
      if (!this.categoryRevenueData) return {};

      return {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            const percentage = params.percent.toFixed(1);
            return `${params.name}<br/>Doanh thu: ${this.formatMoney(
              params.value,
            )} ₫<br/>Tỷ lệ: ${percentage}%`;
          },
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'left',
          top: 'middle',
        },
        series: [
          {
            name: 'Doanh thu',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: true,
              formatter: (params) => {
                // Có thể ẩn bớt label nếu tỷ lệ quá nhỏ để đỡ rối (tùy chọn)
                // if (params.percent < 2) return '';
                return `${params.name}\n${params.percent.toFixed(1)}%`;
              },
            },
            labelLine: {
              show: true,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
              },
            },
            data: this.categoryRevenueData,
          },
        ],
      };
    },
  },
  watch: {
    align: function () {
      this.open = false;
    },
  },
  methods: {
    normalizer (node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },


    toggle () {
      this.open = !this.open;
    },
    clickContent () {
      this.innerOpen = true;
    },
    async fetchStores () {
      try {
        const response = await axios.get(`${BASE_URL}stores/getStores`);
        const stores = response.data.data;
        this.stores = stores.map((element) => ({
          id: element.id,
          name: element.name,
          shortName: element.shortName,
          suggestionName: `${element.shortName} ( ${element.name})`,
        }));
        this.filteredOptions = [{ data: this.stores }];
      } catch (error) {
        console.error('Error fetching stores:', error);
      }
    },

    onStoreSelected (option) {
      this.filters.storeId = option.item.id;
      this.searchStock = option.item.name;
    },

    onStoreInputChange (text) {
      this.searchStock = text || '';
      const filteredData = this.stores
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);

      this.filteredOptions = [{ data: filteredData }];
    },

    onDateChange () {
      this.selectedPreset = null;
    },

    applyDatePreset (preset) {
      this.selectedPreset = preset;
      const today = moment();

      switch (preset) {
        case 'today':
          this.filters.startDate = today.format('DD/MM/YYYY');
          this.filters.endDate = today.format('DD/MM/YYYY');
          break;
        case 'last7days':
          this.filters.startDate = today
            .clone()
            .subtract(6, 'days')
            .format('DD/MM/YYYY');
          this.filters.endDate = today.format('DD/MM/YYYY');
          break;
        case 'last30days':
          this.filters.startDate = today
            .clone()
            .subtract(29, 'days')
            .format('DD/MM/YYYY');
          this.filters.endDate = today.format('DD/MM/YYYY');
          break;
        case 'thisMonth':
          this.filters.startDate = today
            .clone()
            .startOf('month')
            .format('DD/MM/YYYY');
          this.filters.endDate = today.format('DD/MM/YYYY');
          break;
      }
    },

    async fetchCategoriesAndBrands () {
      try {
        const [categories, brands] = await Promise.all([
          CategoryRepository.get(),
          BrandRepository.get(),
        ]);

        this.categories = categories.list_caterogy || [];
        this.brands = brands.brands || [];
      } catch (error) {
        console.error('Error fetching categories/brands:', error);
        handleApiError(error, this, 'Không thể tải danh mục và thương hiệu');
        this.categories = [];
        this.brands = [];
      }
    },

    async fetchOrderSources () {
      try {
        const response = await ApiService.query('/v1/order-sources')
        this.orderSources = response.data.data.list_order_source || [];
      } catch (error) {
        console.error('Error fetching order sources:', error);
        handleApiError(error, this, 'Không thể tải nguồn đơn hàng');
        this.orderSources = [];
      }
    },


    onComparisonToggle () {
      this.debouncedFetchData();
    },


    async removeFilter (filterKey) {
      const isLastFilter = this.activeFiltersList.length === 1;

      if (isLastFilter) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          'Đây là bộ lọc cuối cùng. Bạn có muốn xóa và đặt lại ngày về 30 ngày gần nhất?',
          {
            title: 'Xác nhận xóa bộ lọc',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Xác nhận',
            cancelTitle: 'Hủy',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        );

        if (!confirmed) {
          return;
        }

        const today = moment();
        this.filters.startDate = today.clone().subtract(29, 'days').format('DD/MM/YYYY');
        this.filters.endDate = today.format('DD/MM/YYYY');
        this.selectedPreset = 'last30days';
      }

      switch (filterKey) {
        case 'dateRange':
          this.filters.startDate = '';
          this.filters.endDate = '';
          this.selectedPreset = null;
          break;
        case 'storeIds':
          this.filters.storeIds = [];
          break;
        case 'categoryIds':
          this.filters.categoryIds = [];
          break;
        case 'brandIds':
          this.filters.brandIds = [];
          break;
        case 'orderSourceIds':
          this.filters.orderSourceIds = [];
          break;
        case 'productSearch':
          this.filters.productSearch = '';
          break;
        case 'search':
          this.filters.search = '';
          break;
        case 'compareWithPreviousPeriod':
          this.filters.compareWithPreviousPeriod = false;
          break;
      }

      this.fetchData();

      if (isLastFilter) {
        this.$bvToast.toast('Đã đặt lại ngày về 30 ngày gần nhất', {
          title: 'Xóa bộ lọc thành công',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000,
        });
      }
    },

    async clearFilters () {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'Bạn có chắc chắn muốn xóa tất cả bộ lọc? Hệ thống sẽ đặt lại ngày về 30 ngày gần nhất.',
        {
          title: 'Xác nhận xóa bộ lọc',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Xác nhận',
          cancelTitle: 'Hủy',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (!confirmed) {
        return;
      }

      const today = moment();
      const startDate = today.clone().subtract(29, 'days').format('DD/MM/YYYY');
      const endDate = today.format('DD/MM/YYYY');

      this.filters = {
        startDate,
        endDate,
        storeIds: [],
        categoryIds: [],
        brandIds: [],
        orderSourceIds: [],
        productSearch: '',
        search: '',
        compareWithPreviousPeriod: false,
        sortBy: 'doanhThuThuan',
        sortOrder: 'desc',
        granularity: 'day',
        metric: 'doanhThuThuan',
      };
      this.selectedPreset = 'last30days';
      this.currentPage = 1;

      this.saveFiltersToStorage();
      this.fetchData();

      this.filterDrawerVisible = false;

      this.$bvToast.toast('Đã đặt lại bộ lọc về 30 ngày gần nhất', {
        title: 'Xóa bộ lọc thành công',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000,
      });
    },

    saveFiltersToStorage () {
      try {
        const storeIdsToSave = this.filters.storeIds.map(store => store.id);
        const categoryIdsToSave = this.filters.categoryIds;
        const brandIdsToSave = this.filters.brandIds.map(brand => brand.id);
        const orderSourceIdsToSave = this.filters.orderSourceIds.map(source => source.id);

        const filtersToSave = {
          ...this.filters,
          storeIds: storeIdsToSave,
          categoryIds: categoryIdsToSave,
          brandIds: brandIdsToSave,
          orderSourceIds: orderSourceIdsToSave,
          selectedPreset: this.selectedPreset,
          perPage: this.perPage,
        };
        localStorage.setItem(
          'productRevenueFilters',
          JSON.stringify(filtersToSave),
        );
      } catch (error) {
        console.error('Error saving filters to localStorage:', error);
      }
    },

    loadFiltersFromStorage () {
      try {
        const saved = localStorage.getItem('productRevenueFilters');
        if (saved) {
          const filters = JSON.parse(saved);

          const savedStoreIds = filters.storeIds || [];
          const savedCategoryIds = filters.categoryIds || [];
          const savedBrandIds = filters.brandIds || [];
          const savedOrderSourceIds = filters.orderSourceIds || [];
          delete filters.storeIds;
          delete filters.categoryIds;
          delete filters.brandIds;
          delete filters.orderSourceIds;

          this.filters = {
            ...this.filters,
            ...filters,
          };
          this.selectedPreset = filters.selectedPreset;
          if (filters.perPage) {
            this.perPage = filters.perPage;
          }

          if (savedStoreIds.length > 0 && this.optionStores.length > 0) {
            const storeIdList = savedStoreIds.map(item =>
              typeof item === 'number' ? item : item.id
            );
            this.filters.storeIds = this.optionStores.filter(
              store => storeIdList.includes(store.id)
            );
          }

          if (savedCategoryIds.length > 0 && this.categories.length > 0) {
            const categoryIdList = savedCategoryIds.map(item =>
              typeof item === 'number' ? item : item.id
            );
            this.filters.categoryIds = categoryIdList.filter(id =>
              this.flattenedCategories.some(cat => cat.id === id)
            );
          }

          if (savedBrandIds.length > 0 && this.brands.length > 0) {
            const brandIdList = savedBrandIds.map(item =>
              typeof item === 'number' ? item : item.id
            );
            this.filters.brandIds = this.brands.filter(
              brand => brandIdList.includes(brand.id)
            );
          }

          if (savedOrderSourceIds.length > 0 && this.orderSources.length > 0) {
            const orderSourceIdList = savedOrderSourceIds.map(item =>
              typeof item === 'number' ? item : item.id
            );
            this.filters.orderSourceIds = this.orderSources.filter(
              source => orderSourceIdList.includes(source.id)
            );
          }

        }
      } catch (error) {
        console.error('Error loading filters from localStorage:', error);
      }
    },

    async fetchData (options = {}) {
      const { skipTableLoading = false } = options;
      if (!this.validateFilters()) return;

      if (!skipTableLoading) {
        this.onLoading = true;
      }
      try {
        const params = this.buildParams();

        const promises = [
          ProductRevenueReportRepository.getOverview(params),
          ProductRevenueReportRepository.getProducts({
            ...params,
            limit: this.perPage,
            offset: (this.currentPage - 1) * this.perPage,
          }),
          ProductRevenueReportRepository.getTrend({
            ...params,
            granularity: this.filters.granularity,
            metric: this.filters.metric,
            compareWithPreviousPeriod: this.filters.compareWithPreviousPeriod,
          }),
          ProductRevenueReportRepository.getCategories({
            startDate: params.startDate,
            endDate: params.endDate,
            storeId: params.storeId,
            sortBy: 'revenue',
            sortOrder: 'desc',
            ...params,
          }),
        ];

        const results = await Promise.all(promises);
        const [overviewRes, productsRes, trendRes, categoryRes] = results;

        const overviewData = overviewRes.data?.data || overviewRes.data;
        this.overview = overviewData.currentPeriod;
        this.updateKPICards(overviewData);

        const productsData = productsRes.data?.data || productsRes.data;
        this.products = productsData.products;
        this.totalCount = productsData.totalCount;

        const trendData = trendRes.data?.data || trendRes.data;
        this.trendData = trendData.dataPoints || [];
        this.trendStatistics = trendData.statistics || null;

        if (trendData.previousPeriod) {
          this.previousTrendData = trendData.previousPeriod.dataPoints || null;
          this.trendComparison = trendData.comparison || null;
        } else {
          this.previousTrendData = null;
          this.trendComparison = null;
        }

        const categoryData = categoryRes.data?.data || categoryRes.data;
        this.categoryRevenueList = categoryData.categories || [];

        this.updateURLParams();

        this.saveFiltersToStorage();

        this.lastUpdated = moment().format('HH:mm:ss DD/MM/YYYY');
      } catch (error) {
        console.error('Error fetching data:', error);
        handleApiError(error, this, 'Không thể tải dữ liệu báo cáo');
      } finally {
        if (!skipTableLoading) {
          this.onLoading = false;
        }
      }
    },

    async triggerAggregation () {
      const AGGREGATION_BUFFER_MS = 3000;
      showLoadingDialog(
        'Đang làm mới dữ liệu...',
        'Yêu cầu đã gửi vào hàng đợi xử lý. Vui lòng chờ vài giây...',
      );
      try {
        const params = this.buildParams();
        await ApiService.post('/v1/product-revenue-report/trigger-aggregation', {
          startDate: params.startDate,
          endDate: params.endDate
        });
        await new Promise(resolve => setTimeout(resolve, AGGREGATION_BUFFER_MS));
        await this.fetchData({ skipTableLoading: true });
      } catch (error) {
        console.error('Error triggering aggregation:', error);
        handleApiError(error, this, 'Không thể làm mới dữ liệu');
      } finally {
        closeSwal();
      }
    },

    validateFilters () {
      return validateDateRange(
        this.filters.startDate,
        this.filters.endDate,
        this,
      );
    },

    buildParams () {
      const storeIds = this.filters.storeIds.map(store => store.id);

      const categoryIds = this.filters.categoryIds;

      const brandIds = this.filters.brandIds.map(brand => brand.id);

      const orderSourceIds = this.filters.orderSourceIds.map(source => source.id);

      return {
        startDate: moment(this.filters.startDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        ),
        endDate: moment(this.filters.endDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        ),
        storeIds: storeIds.length > 0 ? storeIds : undefined,
        categoryIds: categoryIds.length > 0 ? categoryIds : undefined,
        brandIds: brandIds.length > 0 ? brandIds : undefined,
        orderSourceIds: orderSourceIds.length > 0 ? orderSourceIds : undefined,
        productSearch: this.filters.productSearch || undefined,
        search: this.filters.search,
        compareWithPreviousPeriod: this.filters.compareWithPreviousPeriod,
        sortBy: this.filters.sortBy,
        sortOrder: this.filters.sortOrder,
        granularity: this.filters.granularity,
        metric: this.filters.metric,
      };
    },

    updateKPICards (data) {
      const { currentPeriod, growth } = data;
      // currentPeriod.totalSold = SUM(ProductReportSummary.totalSold) — tổng SL bán (unit) trong kỳ, theo filter
      this.kpiCards = [
        {
          label: 'Doanh thu thuần',
          value: this.formatMoney(currentPeriod.doanhThuThuan) + ' ₫',
          growth: growth?.doanhThuThuan || 0,
        },
        {
          label: 'Tổng hóa đơn',
          value: currentPeriod.totalBills?.toLocaleString() || '0',
          growth: growth?.totalBills || 0,
        },
        {
          label: 'Giá trị TB/đơn',
          value: this.formatMoney(currentPeriod.averageOrderValue) + ' ₫',
          growth: growth?.averageOrderValue || 0,
        },
        {
          label: 'Sản phẩm bán',
          value: (currentPeriod.totalSold ?? 0).toLocaleString(),
          growth: growth?.totalSold || 0,
        },
      ];
    },

    async exportReport () {
      if (!this.validateFilters()) return;

      try {
        const params = this.buildParams();

        this.exportModal.show = true;
        this.exportModal.message = 'Đang xử lý xuất báo cáo...';
        this.exportModal.subMessage = 'Vui lòng đợi';
        this.exportModal.progress = 0;

        const response = await ProductRevenueReportRepository.exportReport({
          format: 'excel',
          reportType: 'products',
          filters: params,
        });

        const exportData = response.data?.data || response.data;
        const jobId = exportData.jobId;

        this.exportModal.message = 'Đang xử lý dữ liệu...';
        this.exportModal.subMessage =
          exportData.estimatedTime || 'Ước tính: 1-2 phút';
        this.exportModal.progress = 10;

        let pollCount = 0;
        const maxPolls = 150;
        const pollInterval = setInterval(async () => {
          try {
            pollCount++;
            this.exportModal.progress = Math.min(
              10 + (pollCount / maxPolls) * 80,
              90,
            );

            const statusResponse =
              await ProductRevenueReportRepository.getExportStatus(jobId);
            const statusData = statusResponse.data?.data || statusResponse.data;

            if (statusData.status === 'completed') {
              clearInterval(pollInterval);

              this.exportModal.progress = 100;
              this.exportModal.message = 'Hoàn thành! Đang tải xuống...';

              const downloadUrl =
                ProductRevenueReportRepository.getExportDownloadUrl(jobId);
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute(
                'download',
                statusData.filename || 'revenue-report.xlsx',
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              setTimeout(() => {
                this.exportModal.show = false;
                this.$bvToast.toast('Xuất báo cáo thành công', {
                  title: 'Thành công',
                  variant: 'success',
                  solid: true,
                });
              }, 1000);
            } else if (statusData.status === 'failed') {
              clearInterval(pollInterval);

              this.exportModal.show = false;
              this.$bvToast.toast(
                `Xuất báo cáo thất bại: ${statusData.error}`,
                {
                  title: 'Lỗi',
                  variant: 'danger',
                  solid: true,
                },
              );
            }
          } catch (pollError) {
            clearInterval(pollInterval);
            this.exportModal.show = false;
            console.error('Export status polling error:', pollError);
            handleApiError(
              pollError,
              this,
              'Không thể kiểm tra trạng thái xuất báo cáo',
            );
          }
        }, 2000);

        setTimeout(() => {
          if (this.exportModal.show) {
            clearInterval(pollInterval);
            this.exportModal.show = false;
            this.$bvToast.toast(
              'Xuất báo cáo mất quá nhiều thời gian. Vui lòng thử lại.',
              {
                title: 'Timeout',
                variant: 'warning',
                solid: true,
              },
            );
          }
        }, 300000);
      } catch (error) {
        this.exportModal.show = false;
        console.error('Export error:', error);
        handleApiError(error, this, 'Không thể xuất báo cáo');
      }
    },

    onPageChange (page) {
      this.currentPage = page;
      this.fetchData();
    },

    onPerPageChange () {
      this.currentPage = 1;
      this.fetchData();
    },

    onSortChanged (ctx) {
      this.currentSort = ctx.sortBy;
      this.sortDirection = ctx.sortDesc ? 'desc' : 'asc';
      this.filters.sortBy = ctx.sortBy;
      this.filters.sortOrder = this.sortDirection;
      this.fetchData();
    },

    formatMoney (number) {
      return new Intl.NumberFormat('vi-VN').format(number || 0);
    },

    formatMoneyShort (number) {
      if (number >= 1000000000) {
        return (number / 1000000000).toFixed(1) + 'B';
      } else if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + 'M';
      } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K';
      }
      return number?.toString() || '0';
    },

    formatNumberShort (number) {
      if (number >= 1000000000) return (number / 1000000000).toFixed(1) + 'B';
      if (number >= 1000000) return (number / 1000000).toFixed(1) + 'M';
      if (number >= 1000) return (number / 1000).toFixed(1) + 'K';
      return number?.toString() || '0';
    },

    formatMetricValue (value, short = false) {
      if (!value && value !== 0) return '0';

      switch (this.filters.metric) {
        case 'doanhThuThuan':
          return short ? this.formatMoneyShort(value) : this.formatMoney(value);
        case 'totalBills':
        case 'totalSold':
          return short ? this.formatNumberShort(value) : value.toLocaleString();
        default:
          return value.toString();
      }
    },

    getMetricLabel (metric) {
      const labels = {
        doanhThuThuan: 'Doanh thu thuần (₫)',
        totalBills: 'Tổng hóa đơn',
        totalSold: 'Sản phẩm bán',
      };
      return labels[metric] || metric;
    },

    getTrendColor (trend) {
      if (!trend) return '#3699FF';
      const colors = {
        growing: '#1BC5BD',
        declining: '#F64E60',
        stable: '#B5B5C3',
      };
      return colors[trend] || '#3699FF';
    },

    getTrendClass (growthRate) {
      if (growthRate > 0) return 'text-success';
      if (growthRate < 0) return 'text-danger';
      return 'text-muted';
    },

    getTrendBadgeVariant (trend) {
      const variants = {
        growing: 'success',
        declining: 'danger',
        stable: 'secondary',
      };
      return variants[trend] || 'secondary';
    },

    getTrendLabel (trend) {
      const labels = {
        growing: 'Tăng trưởng',
        declining: 'Suy giảm',
        stable: 'Ổn định',
      };
      return labels[trend] || trend;
    },

    getComparisonVariant (trend) {
      return trend === 'increase'
        ? 'success'
        : trend === 'decrease'
          ? 'warning'
          : 'info';
    },

    formatPeriod (period) {
      if (!period) return '';

      switch (this.filters.granularity) {
        case 'day':
          return moment(period).format('DD/MM');
        case 'week':
          return period;
        case 'month':
          return moment(period, 'YYYY-MM').format('MM/YYYY');
        default:
          return period;
      }
    },

    getGrowthClass (growth) {
      return growth > 0
        ? 'text-success'
        : growth < 0
          ? 'text-danger'
          : 'text-muted';
    },

    /**
     * Load filters from URL query params for shareable links
     */
    loadFiltersFromURL () {
      const query = this.$route.query;

      if (query.startDate) {
        this.filters.startDate = moment(query.startDate, 'YYYY-MM-DD').format(
          'DD/MM/YYYY'
        );
      }
      if (query.endDate) {
        this.filters.endDate = moment(query.endDate, 'YYYY-MM-DD').format(
          'DD/MM/YYYY'
        );
      }
      if (query.storeIds) {
        // Parse storeIds from URL (comma-separated or array)
        const storeIdList = Array.isArray(query.storeIds)
          ? query.storeIds.map(id => parseInt(id))
          : query.storeIds.split(',').map(id => parseInt(id));
        // Will be restored to objects after optionStores are loaded
        this.pendingStoreIds = storeIdList;
      }
      if (query.categoryIds) {
        const categoryIdList = Array.isArray(query.categoryIds)
          ? query.categoryIds.map(id => parseInt(id))
          : query.categoryIds.split(',').map(id => parseInt(id));
        // Treeselect stores IDs directly (no need to convert to objects)
        this.filters.categoryIds = categoryIdList;
      }
      if (query.brandIds) {
        const brandIdList = Array.isArray(query.brandIds)
          ? query.brandIds.map(id => parseInt(id))
          : query.brandIds.split(',').map(id => parseInt(id));
        // Store IDs temporarily, will be converted to full objects after brands are loaded
        this.filters.brandIds = brandIdList.map(id => ({ id }));
      }
      if (query.orderSourceIds) {
        const orderSourceIdList = Array.isArray(query.orderSourceIds)
          ? query.orderSourceIds.map(id => parseInt(id))
          : query.orderSourceIds.split(',').map(id => parseInt(id));
        // Store IDs temporarily, will be converted to full objects after order sources are loaded
        this.pendingOrderSourceIds = orderSourceIdList;
      }
      if (query.productSearch) {
        this.filters.productSearch = query.productSearch;
      }
      if (query.search) {
        this.filters.search = query.search;
      }
      if (query.compareWithPreviousPeriod === 'true') {
        this.filters.compareWithPreviousPeriod = true;
      }
      if (query.page) {
        this.currentPage = parseInt(query.page);
      }
      if (query.perPage) {
        this.perPage = parseInt(query.perPage);
      }
    },

    /**
     * Update URL query params when filters change (for shareable links)
     */
    updateURLParams () {
      const query = {};

      if (this.filters.startDate) {
        query.startDate = moment(this.filters.startDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        );
      }
      if (this.filters.endDate) {
        query.endDate = moment(this.filters.endDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        );
      }
      if (this.filters.storeIds.length > 0) {
        query.storeIds = this.filters.storeIds.map(s => s.id).join(',');
      }
      if (this.filters.categoryIds.length > 0) {
        // Treeselect already stores IDs directly
        query.categoryIds = this.filters.categoryIds.join(',');
      }
      if (this.filters.brandIds.length > 0) {
        query.brandIds = this.filters.brandIds.map(b => b.id).join(',');
      }
      if (this.filters.orderSourceIds.length > 0) {
        query.orderSourceIds = this.filters.orderSourceIds.map(s => s.id).join(',');
      }
      if (this.filters.productSearch) {
        query.productSearch = this.filters.productSearch;
      }
      if (this.filters.search) {
        query.search = this.filters.search;
      }
      if (this.filters.compareWithPreviousPeriod) {
        query.compareWithPreviousPeriod = 'true';
      }
      if (this.currentPage > 1) {
        query.page = this.currentPage;
      }
      if (this.perPage !== 5) {
        query.perPage = this.perPage;
      }

      // Update URL without reload
      this.$router.replace({ query }).catch(() => { });
    },

    /**
     * Apply filters and optionally close drawer
     */
    applyFiltersAndClose () {
      this.fetchData();
      // Uncomment to auto-close drawer after apply
      this.filterDrawerVisible = false;
    },

    /**
     * Drawer shown event - focus first input
     */
    onDrawerShown () {
      this.$nextTick(() => {
        const firstInput = document.querySelector(
          '#product-filter-drawer input',
        );
        if (firstInput) {
          firstInput.focus();
        }
      });
    },

    /**
     * Drawer hidden event - save state
     */
    onDrawerHidden () {
      // Optional: Save drawer state to localStorage
      try {
        localStorage.setItem('filterDrawerState', 'closed');
      } catch (error) {
        console.error('Error saving drawer state:', error);
      }
    },

    handleKeyboardShortcuts (event) {
      // Ctrl/Cmd + F to open filter drawer
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault();
        this.filterDrawerVisible = true;
        return;
      }

      // Ctrl/Cmd + Enter to apply filters
      if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
        event.preventDefault();
        if (this.filterDrawerVisible) {
          this.applyFiltersAndClose();
        } else {
          this.fetchData();
        }
        return;
      }

      // Ctrl/Cmd + E to export
      if ((event.ctrlKey || event.metaKey) && event.key === 'e') {
        event.preventDefault();
        this.exportReport();
        return;
      }

      // Escape to close drawer or clear filters
      if (event.key === 'Escape') {
        event.preventDefault();
        if (this.filterDrawerVisible) {
          this.filterDrawerVisible = false;
        } else if (this.activeFiltersCount > 0) {
          this.clearFilters();
        }
      }
    },
  },
  async mounted () {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Báo cáo doanh thu sản phẩm', route: 'product-revenue-report' },
    ]);

    // Load stores (using mixin) and categories/brands in parallel
    const [stores] = await Promise.all([
      this.fetchStoreByUser(),
      this.fetchCategoriesAndBrands(),
      this.fetchOrderSources()
    ]);

    // Set optionStores for BDropdownCustom
    this.optionStores = stores;
    this.stores = stores;

    // Load filters from URL query params (for shareable links)
    this.loadFiltersFromURL();

    // Restore storeIds from URL pending IDs
    if (this.pendingStoreIds.length > 0) {
      this.filters.storeIds = this.optionStores.filter(
        store => this.pendingStoreIds.includes(store.id)
      );
      this.pendingStoreIds = [];
    }

    // Restore orderSourceIds from URL pending IDs
    if (this.pendingOrderSourceIds.length > 0) {
      this.filters.orderSourceIds = this.orderSources.filter(
        source => this.pendingOrderSourceIds.includes(source.id)
      );
      this.pendingOrderSourceIds = [];
    }

    // Load saved filters from localStorage (if no URL params)
    if (!this.$route.query.startDate) {
      this.loadFiltersFromStorage();
    }

    // Auto-select if only one store available
    if (this.optionStores.length === 1 && this.filters.storeIds.length === 0) {
      this.filters.storeIds = this.optionStores;
    }

    if (this.filters.startDate && this.filters.endDate) {
      this.fetchData();
    }

    // Add keyboard shortcuts
    window.addEventListener('keydown', this.handleKeyboardShortcuts);
  },
  beforeDestroy () {
    // Remove keyboard shortcuts
    window.removeEventListener('keydown', this.handleKeyboardShortcuts);
  },
};
</script>

<style scoped>
#drawer-store-input {
  display: block;
  width: 100%;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e5eaee;
  border-radius: 0.28rem;
}

#drawer-store-input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

.chart-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 0.25rem;
}

.filter-badge {
  display: inline-flex;
  align-items: center;
  max-width: 235px;
}

.filter-badge-label {
  display: inline-block;
  max-width: 175px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-badge .btn-link:hover {
  opacity: 0.8;
}

/* Filter Drawer Container */
#product-filter-drawer {
  --bs-sidebar-width: 400px;
}

#product-filter-drawer .drawer-body {
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  padding: 0 !important;
}

/* Filter Section Styling */
.filter-section {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 1rem;
  position: relative;
}

.filter-section:last-child {
  border-bottom: none;
}

.filter-section-title {
  font-size: 1.075rem;
  font-weight: 600;
  color: #3f4254;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.filter-section-title i {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

/* Drawer Footer Sticky */
#product-filter-drawer .drawer-footer {
  padding: 1rem;
  background: #fff;
  border-top: 1px solid #e5e5e5;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
}

/* Date Preset Buttons in Drawer */
.filter-section .btn-group .btn,
.filter-section .d-flex .btn {
  flex: 1 1 calc(50% - 0.5rem);
  min-width: 0;
}

/* Autosuggest in Drawer */
#drawer-store-input {
  width: 100%;
}

/* Filter Trigger Button Animation */
.btn:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

/* Badge in button */
.btn .badge-light {
  background-color: rgba(255, 255, 255, 0.3);
  color: inherit;
  font-weight: 600;
}

/* Responsive Drawer Width */
@media (max-width: 991px) {
  #product-filter-drawer {
    --bs-sidebar-width: 350px;
  }
}

@media (max-width: 767px) {
  #product-filter-drawer {
    --bs-sidebar-width: 90%;
  }

  /* Adjust button sizes on mobile */
  .drawer-footer .btn {
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
  }

  /* Stack preset buttons on mobile */
  .filter-section .d-flex .btn {
    flex: 1 1 calc(50% - 0.25rem);
  }
}

/* Trend Controls Card */
.trend-controls-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 1px solid #e5e9f2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.trend-controls-card label {
  display: block;
  margin-bottom: 0.5rem;
  color: #6c757d;
}

.trend-controls-card .btn-group .btn {
  font-size: 0.875rem;
  font-weight: 500;
}

/* Statistics Mini Cards */
.stat-mini-card {
  text-align: center;
  padding: 1rem;
  border: 1px solid #e5e9f2;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.stat-mini-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.stat-label i {
  font-size: 1rem;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #3f4254;
  margin-bottom: 0.25rem;
  line-height: 1.2;
}

.stat-mini-card small {
  display: block;
  font-size: 0.75rem;
  color: #95a1ac;
}

/* Comparison Alert Enhancement */
.alert {
  border-radius: 0.5rem;
  border-left-width: 4px;
}

.alert.alert-success {
  background-color: #e8f8f5;
  border-left-color: #1bc5bd;
}

.alert.alert-warning {
  background-color: #fff8f0;
  border-left-color: #ffa800;
}

.alert.alert-info {
  background-color: #e1f0ff;
  border-left-color: #3699ff;
}

/* .table-responsive {
  -webkit-overflow-scrolling: touch;
  border-radius: 0.25rem;
  width: min(calc(89%), 1200px);
} */

/* Responsive Design & Touch-Friendly Improvements */
@media (max-width: 767px) {
  /* Ensure adequate touch targets (min 44x44px) */
  .btn,
  .form-control,
  .custom-select {
    min-height: 44px;
    padding: 0.5rem 0.75rem;
  }

  /* Stack KPI cards */
  .kpi-card {
    margin-bottom: 1rem;
  }

  /* Better spacing for mobile */
  .mb-md-0 {
    margin-bottom: 0.5rem !important;
  }

  /* Optimize table for mobile */
  /* .table-responsive {
    -webkit-overflow-scrolling: touch;
    border-radius: 0.25rem;
    width: min(calc(100% - 5vw), 1200px);
  } */

  .table th,
  .table td {
    white-space: nowrap;
    font-size: 0.875rem;
    padding: 0.5rem;
  }

  /* Smaller pagination on mobile */
  .pagination {
    margin-bottom: 0;
  }

  /* Better card spacing */
  .card {
    margin-bottom: 1rem;
  }
}

/* Tablet optimizations */
@media (min-width: 768px) and (max-width: 991px) {
  .table th,
  .table td {
    font-size: 0.9rem;
    padding: 0.6rem;
  }
}

/* Smooth scrolling for table on touch devices */
/* .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: min(calc(100% - 5vw), 1200px);
} */

/* Better button group spacing on mobile */
@media (max-width: 767px) {
  .btn-group-sm > .btn {
    font-size: 0.75rem;
    padding: 0.35rem 0.5rem;
  }
}

#product-filter-drawer ::v-deep .vue-treeselect__placeholder {
  color: #464e5f;
}

/* 
#product-filter-drawer ::v-deep .vue-treeselect__control {
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  color: #495057;
  background-color: #fff;
  border: 1px solid #e5eaee;
  border-radius: 0.28rem;
}

#product-filter-drawer ::v-deep .vue-treeselect__control--is-focused {
  border-color: #92c5f9;
  box-shadow: 0 0 0 0.2rem rgba(54, 153, 255, 0.25);
}

#product-filter-drawer ::v-deep .vue-treeselect__placeholder {
  color: #6c757d;
} 
#product-filter-drawer ::v-deep .vue-treeselect__multi-value {
  background-color: #3699ff;
  color: #fff;
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  margin: 0.125rem;
  font-size: 0.875rem;
}

#product-filter-drawer ::v-deep .vue-treeselect__multi-value-label {
  color: #fff;
}

#product-filter-drawer ::v-deep .vue-treeselect__value-remove {
  color: #fff;
  opacity: 0.7;
}

#product-filter-drawer ::v-deep .vue-treeselect__value-remove:hover {
  opacity: 1;
}

#product-filter-drawer ::v-deep .vue-treeselect__menu-container {
  z-index: 1050;
}

#product-filter-drawer ::v-deep .vue-treeselect__menu {
  border-color: #e5eaee;
  border-radius: 0.28rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 300px;
}

#product-filter-drawer ::v-deep .vue-treeselect__option--selected {
  background-color: #e3f2fd;
  color: #0d5ab5;
  font-weight: 500;
}

#product-filter-drawer ::v-deep .vue-treeselect__option--highlight {
  background-color: #f8f9fa;
}

#product-filter-drawer ::v-deep .vue-treeselect__checkbox {
  border-color: #3699ff;
  border-radius: 0.25rem;
}

#product-filter-drawer ::v-deep .vue-treeselect__checkbox--checked {
  background-color: #3699ff;
  border-color: #3699ff;
}

#product-filter-drawer ::v-deep .vue-treeselect__checkbox--indeterminate {
  background-color: #92c5f9;
  border-color: #3699ff;
}

#product-filter-drawer ::v-deep .vue-treeselect__label {
  color: #3f4254;
  font-size: 0.925rem;
}

#product-filter-drawer ::v-deep .vue-treeselect__indent-level-1 {
  padding-left: 20px !important;
}

#product-filter-drawer ::v-deep .vue-treeselect__indent-level-2 {
  padding-left: 40px !important;
}

#product-filter-drawer ::v-deep .vue-treeselect__indent-level-3 {
  padding-left: 60px !important;
} */

/* 
  #product-filter-drawer ::v-deep .vue-treeselect__input-container {
    padding-top: 0px;
  } */

#product-filter-drawer ::v-deep .vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  /* height: 2.5rem; */
}
</style>
